import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Registrar componentes de Chart.js y el plugin de etiquetas
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const AvanceProyectosChartBarras = ({ data }) => {
  // Extraer valores
  const proyectos = data.map((item) => item.codigo);
  const avanceProgramado = data.map((item) => Math.round(parseFloat(item.avanceProgramado)));
  const avanceEjecutado = data.map((item) => Math.round(parseFloat(item.avanceEjecutado)));

  // Definir datos para Chart.js
  const chartData = {
    labels: proyectos,
    datasets: [
      {
        label: "% Avance Programado (P)",
        data: avanceProgramado,
        backgroundColor: "rgba(54, 162, 235, 0.7)",
        metadata: data.map((item) => item.fecha_corte),
        barPercentage: 0.8,       // mantiene barras gruesas
        categoryPercentage: 0.6   // deja más aire entre categorías
      },
      {
        label: "% Avance Ejecutado (E)",
        data: avanceEjecutado,
        backgroundColor: "rgba(255, 165, 0, 0.6)",
        metadata: data.map((item) => item.fecha_corte),
        barPercentage: 0.8,       // mantiene barras gruesas
        categoryPercentage: 0.6   // deja más aire entre categorías
      }
    ]

  };

  // Opciones del gráfico
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y",
    layout: {
      padding: {
        top: 20,
        bottom: 20,
        left: 10,  // espacio para que las etiquetas no se encimen
        right: 30
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
      },
      y: {
        ticks: {
          autoSkip: false,
          padding: 10, // espacio extra entre categorías
        }
      }
    },
    plugins: {
      legend: { position: "top" },
      datalabels: {
        color: "#000",
        anchor: "end",
        align: "end",
        clamp: true,
        clip: false,
        font: { size: 12 },
        formatter: (value) => value + "%"
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const index = tooltipItem.dataIndex;
            const fechaActualizacion = tooltipItem.dataset.metadata[index];
            return [
              `${tooltipItem.dataset.label}: ${tooltipItem.raw.toFixed(0)}%`,
              `Fecha de Corte: ${fechaActualizacion}`
            ];
          },
        },
      },
    },
  };


  return (
    <div style={{ height: "100%", width: "100%", padding: "10px" }}>
      <Bar
        data={chartData}
        options={{ ...options, maintainAspectRatio: false }}
        plugins={[ChartDataLabels]}
      />
    </div>
  );

};

export default AvanceProyectosChartBarras;
